// extracted by mini-css-extract-plugin
export default {"loadingPage":"LoadingPage_loadingPage__SoBgv"};